import { showSpinner, hideSpinner } from "store/slices/spinner";
import { api } from "store/slices/api";
import {
  createQuoteService,
  emailNotificationService,
  duplicateQuoteService,
  getBulkProductsService,
  prcService,
  emailService,
  pdfService,
  searchQuoteService,
  laborCodeService,
  checkDuplicateNameService,
  createPRCService,
  updatePRCService,
} from "services/priceQuote.service";
import {
  getLaborCodeList,
  getPrcList as getPrcListAction,
  duplicateQuote as duplicateQuoteAction,
  getBulkQuoteData as getBulkQuoteDataAction,
} from "store/slices/priceQuote";
import { toast } from "react-toastify";

export const createQuoteSubmit = (data) => async (dispatch) => {
  try {
    dispatch(showSpinner());
    const res = await createQuoteService(data);
    dispatch(api.util.invalidateTags(["Quote"]));
    return res;
  } catch (err) {
    console.log("err", err);
  } finally {
    dispatch(hideSpinner());
  }
};

export const getlaborCodeValues = (storeNum) => async (dispatch) => {
  const res = await laborCodeService(storeNum);
  dispatch(getLaborCodeList(res));
};

export const getPrcList = (data) => async (dispatch) => {
  try {
    dispatch(showSpinner("getPrcList"));
    const res = await prcService(data);
    dispatch(getPrcListAction(res.prcList ?? []));
    return res;
  } finally {
    dispatch(hideSpinner("getPrcList"));
  }
};

export const sendEmail = (data) => async (dispatch) => {
  return emailService(data);
};

export const pdfBlob = (quoteId) => async (dispatch) => {
  try {
    dispatch(showSpinner());
    return await pdfService(quoteId);
  } catch (err) {
    console.log("err", err);
  } finally {
    dispatch(hideSpinner());
  }
};

export const emailNotification = (quoteId) => async (dispatch) => {
  try {
    dispatch(showSpinner());
    const res = await emailNotificationService(quoteId);
    dispatch(hideSpinner());
    return res;
  } catch (err) {
    console.log("err", err);
  } finally {
    dispatch(hideSpinner());
  }
};

export const fromEmailVal =
  ({ employee, storeNumber }) =>
  async () => {
    const { firstname, lastname, email, jobTitle, isStoreEmp, storeCcn, usePreferredName, preferredName } =
      employee || {};
    let name = (usePreferredName === "Y" ? preferredName : firstname) + " " + lastname;
    var fromEmail = "";
    if (!isStoreEmp || isStoreEmp === "N") {
      fromEmail = email;
    } else {
      if (!storeCcn || storeCcn === "") {
        fromEmail = "sw" + storeNumber + "@sherwin.com";
      } else {
        fromEmail = "sw" + storeCcn + "@sherwin.com";
      }
    }
    return { name, jobTitle, fromEmail };
  };

export const duplicateQuote = (id) => async (dispatch) => {
  try {
    dispatch(showSpinner());
    const res = await duplicateQuoteService(id);
    res.quoteData.floorList.map((ele) => {
      ele.material = ele.material == null ? "0" : ele.material;
      ele.labor = ele.labor == null ? "0" : ele.labor;
      ele.subTotal = ele.subTotal == null ? "0" : ele.subTotal;
      ele.salesTax = ele.salesTax == null ? "0" : ele.salesTax;
      ele.total = ele.total == null ? "0" : ele.total;
    });
    dispatch(duplicateQuoteAction(res));
    return res;
  } catch (err) {
    toast.error("Error during quote duplication");
  } finally {
    dispatch(hideSpinner());
  }
};

export const checkQuoteName = (quoteName) => async (dispatch) => {
  return await checkDuplicateNameService(quoteName);
};

export const getBulkQuoteData = (data) => async (dispatch) => {
  try {
    dispatch(showSpinner("priceQuote:getBulkQuoteData"));
    const res = await getBulkProductsService(data);
    dispatch(getBulkQuoteDataAction(res));
    return res;
  } catch (err) {
    console.log("err", err);
  } finally {
    dispatch(hideSpinner("priceQuote:getBulkQuoteData"));
  }
};

export const createPRC = (payload) => async (dispatch) => {
  try {
    dispatch(showSpinner());
    return await createPRCService(payload);
  } catch (err) {
    const externalSystemError = err?.response?.data?.topLevelStatusMessage?.toString();
    if (externalSystemError.includes("MAIN ACCOUNT") && payload.descr !== "Main Account") {
      return await dispatch(createPRC({ ...payload, descr: "Main Account" }));
    }
    toast.error(err?.detail ?? externalSystemError ?? "Could not create PRC. Please try again.");
  } finally {
    dispatch(hideSpinner());
  }
};

export const updatePRCData = (payload) => async (dispatch) => {
  try {
    dispatch(showSpinner());
    return await updatePRCService(payload);
  } catch (err) {
    toast.error(err?.detail ?? err?.response?.data?.topLevelStatusMessage ?? "Could not update PRC. Please try again.");
  } finally {
    dispatch(hideSpinner());
  }
};
